module.exports = __webpack_public_path__ + "img/OEHUB-04-takeoff.bdcddd35.jpg";